import { css } from "@emotion/react";

import { Close } from "@livechat/design-system-icons";
import {
  Button,
  DesignToken,
  Icon,
  RadiusToken,
  ShadowToken,
  SpacingToken,
} from "@livechat/design-system-react-components";

import { CannedResponseContent } from "components/canned-response-content/CannedResponseContent";
import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { ICannedResponse } from "store/entities/canned-responses";
import { withVar } from "themes/helpers";

interface IProps {
  cannedResponse: ICannedResponse;
  onClear: () => void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const CannedResponsePreview = ({ cannedResponse, onClear }: IProps) => (
  <Flex
    column
    borderRadius={withVar(RadiusToken.Radius3)}
    bg={withVar(DesignToken.SurfacePrimaryDefault)}
    css={css({
      boxShadow: withVar(ShadowToken.Float),
    })}
  >
    <Flex
      justifyContent="space-between"
      alignItems="center"
      paddingLeft="20px"
      paddingRight={withVar(SpacingToken.Spacing2)}
      paddingV={withVar(SpacingToken.Spacing2)}
      css={css({
        boxShadow: withVar(ShadowToken.DividerBottom),
      })}
    >
      <Text fontWeight="600" fontSize="16px">
        Preview
      </Text>
      <Button kind="plain" icon={<Icon source={Close} />} size="compact" onClick={onClear} />
    </Flex>
    <Flex margin="20px" column>
      <CannedResponseContent cannedResponse={cannedResponse} fullWidth />
    </Flex>
  </Flex>
);
